module.exports = __webpack_public_path__ + "static/media/equalicare-img07.47068e6c.png";